import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUploadEmployeeInfoMutation } from "../../features/employee/employeeApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";
import SuccessModal from "../Report/SuccessModal";

export default function UserInfoModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const navigate = useNavigate();
  const [uploadEmployeeInfo, { isLoading, isError, error, isSuccess }] =
    useUploadEmployeeInfoMutation();
  useError(isError, error, "Upload user info fail");
  const [formData, setFormData] = useState<FormData | null>(null);
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "User info updated successfully");
      // if (data?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
      handleOpen({ type: "SUCCESS" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, navigate]);

  return (
    <>
      <UploadExcelModal
        open={open}
        handleClose={handleClose}
        isLoading={false}
        handler={setFormData}
        title="Update User Info Data in Bulk"
        warningText="Please enter the year as a four-digit number (e.g., 2025, 2024) and the month as a number (e.g., 1 for January, 12 for December)."
        downloadLink={"/employee_info_bulk_update.xlsx"}
        footer={
          <Space size={12}>
            {childOpen?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={childOpen?.open}
                handleClose={childClose}
              />
            )}
            <Button
              className="modal-button"
              type="primary"
              loading={isLoading}
              onClick={() => uploadEmployeeInfo(formData)}
            >
              Upload
            </Button>
          </Space>
        }
      />
    </>
  );
}
